export default __webpack_public_path__ + "static/media/loader.5ba9600c.svg";